import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';

const CardNodeTitle = ({children, className}: any) => {
  return <div className={clsx('title', className)}>{children}</div>;
};

export {CardNodeTitle};

CardNodeTitle.propTypes = {
  /**
   * Pass in the children that will be rendered within the CardNodeTitle
   */
  children: PropTypes.node,

  /**
   * Provide an optional class to be applied on the outer element
   */
  className: PropTypes.string,
};
